__turbopack_context__.v({
  "fallback": "ShareButton-module__8Pabba__fallback",
  "fallbackInput": "ShareButton-module__8Pabba__fallbackInput",
  "fallbackLabel": "ShareButton-module__8Pabba__fallbackLabel",
  "fallbackMessage": "ShareButton-module__8Pabba__fallbackMessage",
  "wrapper": "ShareButton-module__8Pabba__wrapper",
});
